import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { COMPLIANCE, REVIEW } from "const"
import { CcLibrarySet, CcLibrarySetModule } from "server/models"
import { CcLibraryModule } from "client/utils"
import {
    StoreType,
    AddCcLibrarySetModule,
    CreateCcComplianceRevision,

    setCcLibrarySetModuleData,
    setCcLibrarySetModuleShowConfirm,
    setCcLibrarySetReloadList,
} from "client/store"
import { CheckButton } from "client/components"

interface ModuleCheckboxProps {
    set: CcLibrarySet
    module: CcLibraryModule
}

const ModuleCheckbox = ({
    set,
    module,
}: ModuleCheckboxProps) => {
    const setModuleData = useSelector((state: StoreType) => state.ccLibrarySetModule.data)
    const dispatch = useDispatch()

    const onChange = (checked: boolean) => {
        if (setModuleData) return

        const data: CcLibrarySetModule = {
            setId: set.id,
            module,
        }

        if (checked) {
            dispatch(setCcLibrarySetModuleData(data))
            dispatch(setCcLibrarySetModuleShowConfirm(true))
        } else {
            const promiseArray: Promise<any>[] = [
                AddCcLibrarySetModule(data),
            ]

            if (module === COMPLIANCE) {
                promiseArray.push(CreateCcComplianceRevision(set.id))
            }
            if (module === REVIEW) {
                // for review module revisions are created from the list view on changing selected file/version
            }

            Promise.all(promiseArray).then(() => {
                dispatch(setCcLibrarySetModuleData(null))

                dispatch(setCcLibrarySetReloadList(false))
                setTimeout(() => {
                    dispatch(setCcLibrarySetReloadList(true))
                }, 0)
            })
        }
    }

    let checked = false
    set.modules.forEach((row) => {
        if (row.module === module) checked = true
    })

    return (
        <CheckButton
            checked={checked}
            padding={false}
            margin={false}
            isLoading={setModuleData && setModuleData.setId === set.id && setModuleData.module === module}
            onChange={() => onChange(checked)}
        />
    )
}
export default ModuleCheckbox
